module.exports = __webpack_public_path__ + "static/img/5.534e32d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/5.jpg
// module id = bZ8B
// module chunks = 1